<i18n
  src="@/locales/views/organization/partners/crop_fields/list_crop_fields.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/crop_field.yml" lang="yaml"></i18n>

<template>
  <bread-crumbs :labels="[module_name]" />
  <template v-if="load_data_general">

    <tabs-container v-model="option_tabs" :with_routing="false" />

    <template v-if="current_tab_data_charged">

      <div class="mt-8 flex flex-row justify-between">
        <div class="panel-plain-label space-x-2">
          <badge-default :label="(total_crop_fields[current_tab?.id] || 0)  + ' ' + $t('labels.total_number_crop_fields')" />
            <badge-default :label="(total_hectares[current_tab?.id] || 0) + ' ' + $t('labels.total_hectares')" />
              <badge-default :label="(total_square_meters[current_tab?.id] || 0) + ' ' + $t('labels.total_square_meters')" />
        </div>

        <div>
          <button type="button" @click.prevent="downloadRepCropFieldsXlsx()" class="btn-white">
            <i :class="[
              'fa-solid',
              downloading_crop_fields ? 'fa-sync fa-spin' : 'fa-file-excel'
              ]"></i><span class="space-icon"></span>{{ $t("labels.download_crop_fields_button") + ` ${current_tab?.name}` }}
          </button>
          <span class="space-actions" />
          <update-crop-fields :organization_id="organization_id" :crop_field_location_id="current_tab?.id" @update="forceUpdateCropFields()"></update-crop-fields>
        </div>
      </div>

      <div class="mt-4 flex flex-row-reverse gap-2">
        <white-button v-if="filtered[current_tab?.id]" label="Limpiar" @click="clearFilters" />
          <white-button
            label="Filtrar"
            @click="filterCropfields"
            />
            <input
            type="text"
            v-model.trim="filters.organization_crop_field_code[current_tab?.id]"
            :placeholder="$t('model.crop_field.organization_crop_field.crop_field_code')"
            class="shadow-sm focus:ring-[#5c7a2e] focus:border-[#5c7a2e] block sm:text-sm border-slate-300 rounded-md"
            />
            <input
            type="text"
            v-model.trim="filters.producer_fullname[current_tab?.id]"
            :placeholder="$t('model.crop_field.organization_crop_field.organization_producer.producer_id')"
            class="shadow-sm focus:ring-[#5c7a2e] focus:border-[#5c7a2e] block sm:text-sm border-slate-300 rounded-md"
            />
            <input
            type="text"
            v-model.trim="filters.organization_producer_code[current_tab?.id]"
            :placeholder="$t('model.crop_field.organization_crop_field.organization_producer.producer_code')"
            class="shadow-sm focus:ring-[#5c7a2e] focus:border-[#5c7a2e] block sm:text-sm border-slate-300 rounded-md"
            />
      </div>

      <div class="mt-8 flex flex-col">
        <ag-grid-vue class="ag-theme-alpine" :columnDefs="columnDefs" :defaultColDef="defaultColDef"
          :rowData="current_crop_fields" domLayout="autoHeight">
        </ag-grid-vue>
      </div>

      <table-paginator
        v-if="!filtered[current_tab?.id]"
        v-model="current_page[current_tab?.id]"
        :init_current_page="current_page[current_page?.id]"
        :total_rows="total_crop_fields[current_tab?.id]"
        :rows_per_page="rows_per_page"
      />

    </template>

    <loading-message v-else />

  </template>
  <loading-message v-else />
</template>

<script>
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";
import UpdateCropFields from "@/components/views/organization/partners/crop_fields/UpdateCropFields.vue"
import TablePaginator from "@/components/views/layout/TablePaginator.vue";
// import TableActions from "@/components/views/layout/ag_grid/TableActions.vue";
import Requester from "@/views/organization/requesters/partners/crop_fields/list_crop_fields.js";

export default {
  name: "OrgPartnersCropFieldsListCropFields",
  components: { AgGridVue, UpdateCropFields, TablePaginator },
  data() {
    return {
      load_data_general: false,
      downloading_crop_fields: false,
      current_page: {},
      rows_per_page: 10,
      locations: [],
      option_tabs: [],
      total_crop_fields: {},
      total_hectares: {},
      total_square_meters: {},
      paginated_crop_fields: {},
      filtered_crop_fields: {},
      defaultColDef: {
        sortable: true,
        filter: true,
        floatingFilter: false
      },
      force_update: false,
      filtered: {},
      filtering: {},
      filters: {
        organization_producer_code: {},
        producer_fullname: {},
        organization_crop_field_code: {}
      },
      columnDefs: [
        {
          headerName: this.$t(
            "model.crop_field.organization_crop_field.organization_producer.producer_code"
          ),
          field: "organization_crop_field.organization_producer.producer_code",
          filter: true
        },
        {
          headerName: this.$t(
            "model.crop_field.organization_crop_field.organization_producer.producer_id"
          ),
          field: "organization_crop_field.organization_producer.producer.fullname",
          filter: true
        },
        {
          headerName: this.$t(
            "model.crop_field.organization_crop_field.crop_field_code"
          ),
          field: "organization_crop_field.crop_field_code",
          filter: true
        },
        {
          headerName: this.$t("model.crop_field.name"),
          field: "name",
          filter: true
        },
        {
          headerName: this.$t("model.crop_field.hectares"),
          field: "hectares",
          filter: "agNumberColumnFilter",
          cellRenderer: params => {
            return this.numberWithPrecision(params.value);
          }
        },
        {
          headerName: this.$t("model.crop_field.square_meters"),
          field: "square_meters",
          filter: "agNumberColumnFilter",
          cellRenderer: params => {
            return this.numberWithPrecision(params.value);
          }
        },
        {
          headerName: this.$t("model.crop_field.location"),
          field: "organization_crop_field.crop_field_zone.name",
          filter: true
        },
        {
          headerName: this.$t("model.crop_field.crop_id"),
          field: "crop.name",
          filter: true
        },
        {
          headerName: this.$t("model.crop_field.crop_variety_id"),
          field: "crop_variety.name",
          filter: true
        },
        {
          headerName: this.$t("model.crop_field.planting_date"),
          field: "planting_date",
          filter: "agDateColumnFilter",
          cellRenderer: params => {
            return this.dateFormatter(params.value, "MMM YYYY");
          }
        },
        {
          headerName: this.$t("model.crop_field.harvest_time"),
          field: "harvest_time",
          filter: true
        },
        {
          headerName: this.$t("model.crop_field.tree_number"),
          field: "tree_number",
          filter: "agNumberColumnFilter",
          cellRenderer: params => {
            return this.numberWithPrecision(params.value);
          }
        },
        {
          headerName: this.$t("model.crop_field.crop_field_type_id"),
          field: "crop_field_type_name",
          filter: true
        },
        {
          headerName: this.$t("model.crop_field.longitude_dd"),
          field: "longitude_dd",
          filter: "agNumberColumnFilter"
        },
        {
          headerName: this.$t("model.crop_field.latitude_dd"),
          field: "latitude_dd",
          filter: "agNumberColumnFilter"
        },
        {
          headerName: this.$t("model.crop_field.longitude_dms"),
          field: "longitude_dms",
          filter: true
        },
        {
          headerName: this.$t("model.crop_field.latitude_dms"),
          field: "latitude_dms",
          filter: true
        },
        {
          headerName: this.$t("model.crop_field.longitude_utm"),
          field: "longitude_utm",
          filter: true
        },
        {
          headerName: this.$t("model.crop_field.latitude_utm"),
          field: "latitude_utm",
          filter: true
        },
        {
          headerName: this.$t("model.crop_field.zone_utm"),
          field: "zone_utm",
          filter: true
        },
        {
          headerName: this.$t("model.crop_field.altitude"),
          field: "altitude",
          filter: "agNumberColumnFilter",
          cellRenderer: params => {
            return this.numberWithPrecision(params.value);
          }
        },
        // {
        //   headerName: "",
        //   width: 250,
        //   filter: false,
        //   cellRendererSelector: params => {
        //     return {
        //       component: TableActions,
        //       params: {
        //         edit_label: this.$t("labels.edit_button"),
        //         editEvent: this.goToEditCropField,
        //         show_destroy: true,
        //         destroy_label: this.$t(
        //           "labels.destroy_crop_field_button_label"
        //         ),
        //         destroy_title: this.$t(
        //           "labels.destroy_crop_field_button_title",
        //           {
        //             crop_field: params.data.name
        //           }
        //         ),
        //         destroy_message: this.$t(
        //           "labels.destroy_crop_field_button_message",
        //           {
        //             crop_field: params.data.name
        //           }
        //         ),
        //         destroy_label_confirm: this.$t(
        //           "labels.destroy_crop_field_button_label_confirm"
        //         ),
        //         destroyEvent: this.destroyCropField
        //       }
        //     };
        //   }
        // }
      ]
    };
  },
  props: {
    organization_id: {
      required: true
    }
  },
  methods: {
    clearFilters() {
      let current_id = this.current_tab?.id;
      if (!current_id) return;

      this.filters['organization_producer_code'][current_id] = "";
      this.filters['producer_fullname'][current_id] = "";
      this.filters['organization_crop_field_code'][current_id] = "";
      this.filtered[current_id] = false;
      this.filtered_crop_fields[current_id] = [];
    },
    downloadRepCropFieldsXlsx: async function () {
      this.downloading_crop_field = true;
      try {
        var response = await Requester.downloadCropFieldsXlsx(
          this.organization_id,
          this.current_tab?.id
        );
        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `Campos_${this.current_tab?.name}.xlsx`);
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      this.downloading_crop_field = false;
    },
    fetchData: async function(){
      await this.fetchLocations();
      this.fillOptions();
      this.load_data_general = true
    },
    fetchLocations: async function () {
      let response = await Requester.fetchLocations(this.organization_id);
      let locations = response.data;
      locations.forEach(location => this.current_page[location.id] = 1);
      this.locations = locations;
    },
    fetchCropFields: async function () {
      const crop_field_location_id = this.current_tab?.id;
      if (!crop_field_location_id) return;
      this.paginated_crop_fields[crop_field_location_id] = null;
      // if (this.paginated_crop_fields[crop_field_location_id] && !this.force_update) return;

      this.force_update = false;

      let response = await Requester.fetchCropFields(
        this.organization_id,
        crop_field_location_id,
        this.current_page[crop_field_location_id],
        this.rows_per_page
      );

      this.total_crop_fields[crop_field_location_id] = response.data.total_crop_fields;
      this.total_hectares[crop_field_location_id] = this.numberWithPrecision( response.data.total_hectares );
      this.total_square_meters[crop_field_location_id] = this.numberWithPrecision(response.data.total_square_meters);
      this.paginated_crop_fields[crop_field_location_id] = response.data.crop_fields;
    },
    fillOptions: function () {
      this.option_tabs = this.locations.map(location => {
        return {
          id: location.id,
          name: location.name,
          icon: "fa-solid fa-seedling",
        }
      });
      this.option_tabs[0].current = true;
    },
    filterCropfields: async function () {
      const current_id = this.current_tab?.id;
      if (current_id && !this.filtering[current_id] && this.can_filter) {
        this.filtering[current_id] = true;
        let filters = {
          organization_producer_code: this.filters.organization_producer_code[current_id],
          producer_fullname: this.filters.producer_fullname[current_id],
          organization_crop_field_code: this.filters.organization_crop_field_code[current_id]
        }
        let response = await Requester.filterCropfields(
          this.organization_id,
          current_id,
          filters
        )
        this.filtering[current_id] = false;
        this.filtered[current_id] = true;
        this.filtered_crop_fields[current_id] = response.data;
      }
    },
    forceUpdateCropFields: async function () {
      this.force_update = true;
      await this.fetchCropFields();
      this.force_update = false;
    }
  },
  watch: {
    current_tab: function () {
      this.fetchCropFields();
    },
    current_page: {
      handler: async function () {
        this.force_update = true;
        await this.fetchCropFields();
        this.force_update = false;
      },
      deep: true
    }
  },
  computed: {
    can_filter: function () {
      return Object.values(this.filters).some(f => f[this.current_tab?.id]);
    },
    current_tab: function () {
      let current_tab = null;
      const options = this.option_tabs
      Object.keys(options).forEach(key => {
        if (options[key].current) return current_tab = options[key];
      })
      return current_tab;
    },
    current_crop_fields: function () {
      if (this.filtered[this.current_tab?.id]) return this.filtered_crop_fields[this.current_tab?.id];
      return this.paginated_crop_fields[this.current_tab?.id] || [];
    },
    current_tab_data_charged: function () {
      return this.paginated_crop_fields[this.current_tab?.id] && !this.force_update;
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.fetchData())
    );
  }
};
</script>
